import { A11yProvider } from './A11yProvider.js';
import { ToastProvider } from './ToastProvider.js';
import { jsx } from 'react/jsx-runtime';
import { LinkSourceProvider } from '../link/LinkProvider.js';
import { I18nProvider } from '../i18n/I18nProvider.js';

/**
 * Implementation of DSX context provider.
 */
function Provider(props) {
  const {
    linkSources,
    locale,
    portalTarget,
    children,
    toastPortal
  } = props;
  return /*#__PURE__*/jsx(A11yProvider, {
    portalTarget: portalTarget,
    children: /*#__PURE__*/jsx(LinkSourceProvider, {
      linkSources: linkSources,
      children: /*#__PURE__*/jsx(I18nProvider, {
        locale: locale,
        children: /*#__PURE__*/jsx(ToastProvider, {
          toastPortal: toastPortal,
          children: children
        })
      })
    })
  });
}

export { Provider };
